import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import JsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

//Imágenes a utilizar para formar el pdf
import logoM from '../img/LOGO_informe_profesor.png';

function groupRowsByQuestionsId(filteredRows){
    let groupedRows = [];
    filteredRows.forEach((filteredRow) => {
        if(!groupedRows.some(groupedRow => groupedRow.pregunta === filteredRow.pregunta)){
            let row = JSON.parse(JSON.stringify(filteredRow));
            row.num_resp_prof = Number(row.num_resp_prof);
            row.med_resp_prof = Number(row.num_resp_prof) * Number(row.med_resp_prof);
            row.num_resp_dpto_prof = Number(row.num_resp_dpto_prof);
            row.med_resp_dpto_prof = Number(row.num_resp_dpto_prof) * Number(row.med_resp_dpto_prof);
            row.num_resp_facul_prof = Number(row.num_resp_facul_prof);
            row.med_resp_facul_prof = Number(row.num_resp_facul_prof) * Number(row.med_resp_facul_prof);
            row.num_resp_univ_prof = Number(row.num_resp_univ_prof);
            row.med_resp_univ_prof = Number(row.num_resp_univ_prof) * Number(row.med_resp_univ_prof);
            row.num_resp_anuales = Number(row.num_resp_anuales);
            row.med_resp_anuales = Number(row.num_resp_anuales) * Number(row.med_resp_anuales);
            groupedRows.push(row);

        } else {
            const rowIndex = groupedRows.findIndex(groupedRow => groupedRow.pregunta === filteredRow.pregunta);
            groupedRows[rowIndex].num_resp_prof += Number(filteredRow.num_resp_prof);
            groupedRows[rowIndex].med_resp_prof += Number(filteredRow.num_resp_prof) * Number(filteredRow.med_resp_prof);
            groupedRows[rowIndex].num_resp_dpto_prof += Number(filteredRow.num_resp_dpto_prof);
            groupedRows[rowIndex].med_resp_dpto_prof += Number(filteredRow.num_resp_dpto_prof) * Number(filteredRow.med_resp_dpto_prof);
            groupedRows[rowIndex].num_resp_facul_prof += Number(filteredRow.num_resp_facul_prof);
            groupedRows[rowIndex].med_resp_facul_prof += Number(filteredRow.num_resp_facul_prof) * Number(filteredRow.med_resp_facul_prof);
            groupedRows[rowIndex].num_resp_univ_prof += Number(filteredRow.num_resp_univ_prof);
            groupedRows[rowIndex].med_resp_univ_prof += Number(filteredRow.num_resp_univ_prof) * Number(filteredRow.med_resp_univ_prof);
            groupedRows[rowIndex].num_resp_anuales += Number(filteredRow.num_resp_anuales);
            groupedRows[rowIndex].med_resp_anuales += Number(filteredRow.num_resp_anuales) * Number(filteredRow.med_resp_anuales);
        }
    });

    groupedRows.forEach(groupedRow => {
        groupedRow.med_resp_prof = (groupedRow.med_resp_prof/groupedRow.num_resp_prof).toFixed(2);
        groupedRow.med_resp_dpto_prof = (groupedRow.num_resp_dpto_prof > 0) ? (groupedRow.med_resp_dpto_prof/groupedRow.num_resp_dpto_prof).toFixed(2) : 0;
        groupedRow.med_resp_facul_prof = (groupedRow.num_resp_facul_prof > 0) ? (groupedRow.med_resp_facul_prof/groupedRow.num_resp_facul_prof).toFixed(2) : 0;
        groupedRow.med_resp_univ_prof = (groupedRow.num_resp_univ_prof > 0) ? (groupedRow.med_resp_univ_prof/groupedRow.num_resp_univ_prof).toFixed(2) : 0;
        groupedRow.med_resp_anuales = (groupedRow.num_resp_anuales > 0) ? (groupedRow.med_resp_anuales/groupedRow.num_resp_anuales).toFixed(2) : 0;
    })

    return groupedRows;
}

function filterDataByFaculty(faculty, reportData, field){
    return [...reportData.map((item) => {
        if(item.doc_identi === faculty){
            if(field === 'cod_asignatura'){
                return {
                    label: item[field] + ' | ' +
                        item['desc_asignatura']  + ' | ' +
                        item['cod_grupo_simple'] + ' | ' +
                        item['desc_titulacion'],
                    value: item['cod_asignatura'] + '-' + item['cod_grupo_simple']
                }
            } else {
                return {
                    label: item[field],
                    value: item[field]
                }
            }
        };
    })
    .filter((item) => item)
    .filter((item, index, self) =>
        index === self.findIndex((t) => (
            t.value === item.value
        )
    ))];
}

async function generateXSL(filteredRows, facultyName, qualitativeResultData) {
    var dataTableRows = [];
    var qualitativeDataRows = [];
    var qualitativeRows = (qualitativeResultData && qualitativeResultData.length > 0 )
                            ? qualitativeResultData
                            : [
                                {
                                "respuesta": "NO HAY COMENTARIOS",
                                "cur_academ": ""
                                }
                            ];
    filteredRows.forEach(element => {
        dataTableRows.push({
            "Descripción": element.descripcion,
            "N prof": element.num_resp_prof,
            "Media prof": Number(element.med_resp_prof).toFixed(2),
            "N dpto": element.num_resp_dpto_prof,
            "Media dpto": Number(element.med_resp_dpto_prof).toFixed(2),
            "N facultad": element.num_resp_facul_prof,
            "Media facultad": Number(element.med_resp_facul_prof).toFixed(2),
            "N universidad": element.num_resp_univ_prof,
            "Media universidad": Number(element.med_resp_univ_prof).toFixed(2),
            "N global": element.num_resp_anuales,
            "Media global": Number(element.med_resp_anuales).toFixed(2)
        })
    });

    qualitativeRows.forEach(element => {
        qualitativeDataRows.push({
            "Curso Académico": (element.cur_academ !== "") ? (element.cur_academ + "/" + (parseInt(element.cur_academ) + 1)) : '-',
            "Comentarios": element.respuesta
        })
    });

    const worksheet = XLSX.utils.json_to_sheet(dataTableRows);
    const worksheet2 = XLSX.utils.json_to_sheet(qualitativeDataRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte');
    XLSX.utils.book_append_sheet(workbook, worksheet2, 'Comentarios');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    saveAs(data, facultyName + '.xlsx');
};

//Función para cargar imágenes en el pdf de manera asíncrona
const loadImages = (sources) => {
    const loadImage = (src) => new Promise((resolve, reject) => {
        if (!src) {
            resolve(null);
        } else {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error(`Error al cargar la imagen: ${src}`));
            img.src = src;
        }
    });
    return Promise.all(sources.map(src => loadImage(src)));
};


async function generatePDF(filters, facultyName, filteredRows, qualitativeResultData) {
    const fecha = new Date();
    const opciones = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const fechaFormateada = fecha.toLocaleDateString('es-ES', opciones);

    const doc = new JsPDF();

    //Variables auxiliares que nos ayudan a cambiar el valor de cada imagen dependiendo de cada tipo de pdf
    var textProfesorY = 0;
    var tableY = 0;
    var textFooter = '';
    var logoHeight = 0;

    //Según el centro carga unas imágenes u otras
    let sources = {
        img: logoM
    };

    //Uso de la función para cargar las imágenes de manera asíncrona
    const [ img ] = await loadImages(Object.values(sources));

    //Aqui modificaremos los valores de cada imagen para poder adaptarlas al pdf como queramos
    textProfesorY = 65;
    tableY = 81;
    textFooter = 'Universidad Europea - ' + fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);
    logoHeight = 30;

    //Valores de las imágenes para mantener su proporción original
    const imgWidth = img.width;
    const imgHeight = img.height;
    const headerHeight = logoHeight;
    const headerWidth = ((imgWidth * headerHeight) / imgHeight);

    //Primer texto del pdf
    const pageWidth = doc.internal.pageSize.getWidth() - 20;

    //Encabezado
    //El metodo text y addImage tienen estos parametros
    //en común (valor, coordenada_X, coordenada_Y, Ancho, Alto)
    doc.addImage(img.src, 'PNG', 10, 10, headerWidth, headerHeight);

    //Nombre del profesor en el pdf
    doc.setFontSize(16);
    doc.text(`Informe del profesor:`, 100, textProfesorY - 12, null, null, 'center');
    doc.setFont('helvetica', 'italic');
    doc.text(`${facultyName}`, 100, textProfesorY, null, null, 'center');
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    const lines = doc.splitTextToSize("A continuación, verás los resultados cuyas ASIGNATURAS | GRUPOS | TITULACIONES que previamente has seleccionado:", pageWidth);
    doc.text(lines, 15, textProfesorY + 10);

    //Estilos de la tabla
    const headerStyles = {
        fillColor: [196, 48, 43],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        halign: 'center',
        fontSize: 8
    };

    const bodyStyles = {
        fontSize: 8,
        halign: 'center'
    };

    const descriptionStyles = {
        cellWidth: 50,
        halign: 'left'
    }

    const columnStyles1 = {
        cellWidth: 30,
        halign: 'center',
        valign: 'middle'
    }

    const columnStyles2 = (qualitativeResultData && qualitativeResultData.length > 0 ) ?
    {
        cellWidth: 152,
        halign: 'left'
    }
    :
    {
        cellWidth: 152,
        halign: 'center'
    }

    const mediaStyles = {
        cellWidth: 12
    }

     //Definición de la tabla
     autoTable(doc, {
        startY: tableY,
        head: [['Descripción', 'N prof', 'Media prof', 'N dpto', 'Media dpto', 'N facultad', 'Media facultad', 'N universidad', 'Media universidad', 'N global', 'Media global']],
        body: filteredRows.map(
            item => [
                item.descripcion,
                item.num_resp_prof,
                Number(item.med_resp_prof).toFixed(2),
                item.num_resp_dpto_prof,
                Number(item.med_resp_dpto_prof).toFixed(2),
                item.num_resp_facul_prof,
                Number(item.med_resp_facul_prof).toFixed(2),
                item.num_resp_univ_prof,
                Number(item.med_resp_univ_prof).toFixed(2),
                item.num_resp_anuales,
                Number(item.med_resp_anuales).toFixed(2)
            ]
        ),
        headStyles: headerStyles,
        bodyStyles: bodyStyles,
        columnStyles: {
            0: descriptionStyles,
            2: mediaStyles,
            4: mediaStyles
        },
        didDrawPage: function (data) {
                data.settings.margin.top = 40;
        }
    });

    const lastTableY = doc.lastAutoTable.finalY;
    const lines2 = doc.splitTextToSize("A continuación, verás los comentarios cuyas ASIGNATURAS | GRUPOS | TITULACIONES que previamente has seleccionado:", pageWidth);
    doc.text(lines2, 15, lastTableY + 10);

    let qualitativeRows = (qualitativeResultData && qualitativeResultData.length > 0 )
                        ? qualitativeResultData
                        : [
                            {
                              "respuesta": "NO HAY COMENTARIOS",
                              "cur_academ": ""
                            }
                        ];


    autoTable(doc, {
        startY: lastTableY + 17,
        head: [['Curso Academico','Comentarios']],
        body: qualitativeRows.map(
            item => [
                (item.cur_academ !== "") ? (item.cur_academ + "/" + (parseInt(item.cur_academ) + 1)) : '-',
                item.respuesta
            ]
        ),
        headStyles: headerStyles,
        bodyStyles: bodyStyles,
        columnStyles: {
            0: columnStyles1,
            1: columnStyles2
        },
        didDrawPage: function (data) {
                data.settings.margin.top = 40;
        }
    });

    doc.setFontSize(12);
    const pageCount = doc.internal.getNumberOfPages();

    //Bucle para iterar el footer según el número de páginas que se genere del pdf
    for (let i = 1; i <= pageCount; i++) {
        //Texto del footer
        doc.setFont('helvetica', 'italic');
        doc.setPage(i);
        doc.setFontSize(9);
        const x = 190;
        const y = doc.internal.pageSize.getHeight() - 8;
        const lineHeight = 0.1;

        //Línea del footer
        doc.setLineWidth(lineHeight);
        doc.line(2, y - 5, 200, y - 5);
        doc.setTextColor(0,0,0);
        doc.text(`${textFooter}`, x, y, null, null, 'right');

        doc.setFillColor(196, 48, 43); // Color rojo
        // Dibuja el rectángulo con color de fondo
        const rectWidth = 10; // Ancho del rectángulo
        const rectHeight = 8; // Alto del rectángulo
        const rectX = pageWidth + 2; // 10 es el margen derecho
        const rectY = doc.internal.pageSize.getHeight() - rectHeight - 5; // 10 es el margen inferior
        doc.rect(rectX, rectY, rectWidth, rectHeight, 'F'); // 'F' significa relleno

        // Configura el color del texto para el número de página
        doc.setTextColor(255, 255, 255); // Color blanco
        doc.setFontSize(8); // Establece el tamaño de la fuente para el número de página
        // Añade el número de página centrado en el rectángulo
        const pageNumX = rectX + rectWidth / 2;
        const pageNumY = rectY + rectHeight / 2 + 2.5; // Ajusta según la altura de la fuente
        doc.text(String(i), pageNumX, pageNumY, { align: 'center' });

        if (i !== 1) {
            doc.setFont('helvetica', 'italic');
            doc.setPage(i);
            doc.setFontSize(9);
            doc.setTextColor(0, 0, 0);
            doc.addImage(img.src, 'PNG', 10, 10,  headerWidth/2, headerHeight/2);
        }
    }

    doc.save(`Informe profesor ${facultyName}.pdf`);
};

export { groupRowsByQuestionsId, filterDataByFaculty, generateXSL, generatePDF }